"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import { useList } from '../../../../hooks/useList.mjs';
import locales from '../../../../../../../../_virtual/_.locale.json@8d5024994f97657f895a4e2a188d2d8a.mjs';
import { useLocalizedStringFormatter } from 'react-aria';
import ButtonView from '../../../../../../views/ButtonView.mjs';

const ShowNextBatchButton = (props) => {
  const stringFormatter = useLocalizedStringFormatter(locales);
  const list = useList();
  const isLoading = list.loader.useIsLoading();
  const isInitiallyLoading = list.loader.useIsInitiallyLoading();
  const pagination = list.batches;
  const canLoadMore = pagination.hasNextBatch();
  if (!canLoadMore && !isLoading) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    ButtonView,
    {
      isPending: isLoading && !isInitiallyLoading,
      isDisabled: isInitiallyLoading,
      ...props,
      onPress: () => list.batches.nextBatch(),
      variant: "plain",
      size: "s",
      children: stringFormatter.format("list.showMore")
    }
  );
};

export { ShowNextBatchButton, ShowNextBatchButton as default };
//# sourceMappingURL=ShowNextBatchButton.mjs.map
